(function Module() {
	'use strict';

	mySynch.filter('SectionName',[
		'MySynchFactory',
		'F360Constant',
		function (MSF,constant) {
		return function(x) {
			var codeFile = _.cloneDeep(_.get(MSF, 'lists.codeFile', []));
			var arrSection = _.filter(codeFile, {codeType: 'F360SECTION'});
			return _.find(arrSection, { code: x }).codeValue;
		};
	}]);
	mySynch.filter('SubHeadingName',[
		'MySynchFactory',
		'F360Constant',
		function (MSF,constant) {
			return function(x) {
				var codeFile = _.cloneDeep(_.get(MSF, 'lists.codeFile', []));
				var arrSection = _.filter(codeFile, {codeType: 'F360SECTION'});
				var subHeadingName = '';
				arrSection.forEach(item => {
					if (item.detailsJson.length > 0) {
						var detailsJson = JSON.parse(item.detailsJson);
						if (detailsJson[0].subHeadings) {
							detailsJson[0].subHeadings.forEach(sub => {
								if (sub.key == x) {
									if (sub.description) {
										subHeadingName = sub.description;
									} else {
										subHeadingName = sub.Description;
									}
								}
							});
						}
					}
				});
				return subHeadingName;
			};
		}]);
	mySynch.filter('SectionLink',[
		'MySynchFactory',
		'F360Constant',
		function (MSF,constant) {
			return function(x) {
				var codeFile = _.cloneDeep(_.get(MSF, 'lists.codeFile', []));
				var arrSection = _.filter(codeFile, {codeType: 'F360SECTION'});
				var lowercase = _.find(arrSection, { code: x }).codeValue.toLowerCase();
				var stringLink = lowercase.replace(/ /g, "-");
				return stringLink;
			};
		}]);
	mySynch.filter(
		'SubLink',[
		'MySynchFactory',
		function () {
			return function(x) {
				
				var lowercase = x.toLowerCase();
				var stringLink = lowercase.replace(/ /g, "-");
				return stringLink;
			};
	}]);
})();
